<template>
  <div class="col-lg-7 col-md-12 col-sm-12 mb-4">
    <div class="card card-small blog-comments">
      <div class="card-header border-bottom">
        <h6 class="m-0">Postulaciones</h6>
      </div>

      <div class="card-body p-0 border-bottom" v-for="(person, index) in requests" :key="index">
        <div class="blog-comments__item d-flex p-3">
          <div class="blog-comments__avatar mr-3">
            <img src="/images/avatars/unknown-user.png" alt="User avatar"/> </div>
          <div class="blog-comments__content">
            <div class="blog-comments__meta text-muted">
              <a class="text-secondary" :href="'mailto:' + person.email">
                {{ person.names }} {{ person.lastnames }} 
              </a>
              <span class="text-muted">
                - <days-passed :date="person.created_at"/>
              </span>
            </div>
            <p class="m-0 my-1 mb-2 text-muted">
              {{ person.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="blog-comments__item d-flex p-3" v-if="requests.length == 0">
        No tienes postulaciones
      </div>

      <div class="card-footer">
        <div class="row">
          <div class="col text-center view-report">
            <router-link to="/postulaciones" class="btn btn-white">
              Ver todas las postulaciones
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		data() {
			return {
				requests: []
			}
		},

		mounted() {
			this.getRequests();
		},

		methods: {
			async getRequests() {
				let url = process.env.VUE_APP_ROOT_API.concat('/job/card');
				let response = await fetch(url);
				this.requests = await response.json();
			}
		}
	}
</script>